import _, { isEqual, get } from 'lodash';
import { AUTOCOMPLETE_STORAGE_KEY, LOCATION_STORAGE_KEY } from '../constants';

export const MAX_LOCAL_STORAGE = 40;

export const storeQuery = (
    searchQuery,
    storeKey = AUTOCOMPLETE_STORAGE_KEY,
) => {
    try {
        let searchHistory = localStorage.getItem(storeKey);

        if (!_.isEmpty(searchHistory)) {
            searchHistory = searchHistory.split(',');

            searchHistory.unshift(searchQuery);
        } else {
            searchHistory = [searchQuery];
        }

        const autocompleteHistory = _.chain(searchHistory)
            .map(_.trim)
            .compact()
            .uniqWith((val, otherval) => {
                if (storeKey === LOCATION_STORAGE_KEY) {
                    const parsedVal = JSON.parse(val.replace(/;/g, ','));
                    const parsedOtherval = JSON.parse(
                        otherval.replace(/;/g, ','),
                    );

                    return isEqual(
                        get(parsedVal, 'value'),
                        get(parsedOtherval, 'value'),
                    );
                }

                return isEqual(val, otherval);
            })
            .take(MAX_LOCAL_STORAGE)
            .value();

        localStorage.setItem(storeKey, autocompleteHistory);
    } catch (error) {
        // in production, we silently fail and drop the history feature
        if (process.env.NODE_ENV === 'development') {
            throw error;
        }
    }
};
